import axios from 'axios';
import { toastService } from './toastService';

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 300000,
  headers: {
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': 'true',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    return import('./authStorageService')
      .then(({ authStorageService }) => authStorageService.getAuthData())
      .then((authData) => {
        if (authData?.accessToken) {
          config.headers.Authorization = `Bearer ${authData.accessToken}`;
        }
        return config;
      })
      .catch(() => config);
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const isLogoutRequest = error.config?.url?.includes('/logout');
      const isOnLoginPage = window.location.pathname === '/login';
      
      if (!isLogoutRequest && !isOnLoginPage) {
        import('./authStorageService').then(({ authStorageService }) => {
          authStorageService.clearAuthData();
          window.location.href = '/login';
        });
      }
    }

    const AUTH_PAGES = ['/login', '/forgot-password', '/reset-password', '/set-password'];
    const isAuthPage = AUTH_PAGES.includes(window.location.pathname);

    if (!error.config?.suppressToast && !isAuthPage) {
      const message = error.response?.data?.message || error.message || 'An error occurred';
      toastService.error(message);
    }

    return Promise.reject(error);
  }
);

export const apiClient = {
  get: (url, config) => axiosInstance.get(url, config),
  post: (url, data, config) => axiosInstance.post(url, data, config),
  put: (url, data, config) => axiosInstance.put(url, data, config),
  patch: (url, data, config) => axiosInstance.patch(url, data, config),
  delete: (url, config) => axiosInstance.delete(url, config),
  request: (config) => axiosInstance.request(config),
};